export default {
    primaryDarkest: "#008795",
    primaryDark: "#008ba0",
    primary: "#0096ae",
    primaryLight: "#32a9be",
    primaryLightest: "#7dbecf",

    secondaryDarkest: "#00afc9",
    secondaryDark: "#35bad1",
    secondary: "#6ec6d9",
    secondaryLight: "#94d3e1",
    secondaryLightest: "#b3deea",

    tertiaryDarkest: "#b5851f",
    tertiaryDark: "#c09319",
    tertiary: "#cba331",
    tertiaryLight: "#d5b45c",
    tertiaryLightest: "#e1c787",

    grayDarkest: "#616161",
    grayDark: "#757575",
    gray: "#9e9e9e",
    grayLight: "#e0e0e0",
    grayLightest: "#eeeeee",

    success: "#28a745",
    danger: "#dc3545",
    white: "#ffffff",
    black: "#222222",
};
